import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

// Trail: [{to, label}] — last item is current (no link).
export default function Breadcrumbs({ trail = [] }) {
  return (
    <nav aria-label="Breadcrumb" data-testid="breadcrumbs" className="flex items-center flex-wrap gap-2 kbd text-ink-muted">
      {trail.map((t, i) => {
        const last = i === trail.length - 1;
        return (
          <span key={i} className="inline-flex items-center gap-2">
            {i > 0 && <ChevronRight size={12} className="text-ink/30" />}
            {last ? (
              <span className="text-ink">{t.label}</span>
            ) : (
              <Link to={t.to} className="hover:text-ink transition-colors">{t.label}</Link>
            )}
          </span>
        );
      })}
    </nav>
  );
}
